<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Inloggen</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form @submit.prevent="signin">
              <v-alert v-for="(error, index) in errors.non_field_errors" :key="index" :value="error" type="error">{{ error }}</v-alert>
              <v-text-field prepend-icon="fa-user" name="email" label="E-mailadres" type="text" v-model="email" :error-messages="errors.email"></v-text-field>
              <v-text-field id="password" prepend-icon="fa-key" name="password" label="Password" type="password" v-model="password" :error-messages="errors.password"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="signin">Inloggen</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Signin',
  data () {
    return {
      email: '',
      password: '',
      errors: {}
    }
  },
  created () {
    this.checkSignedIn()
  },
  updated () {
    this.checkSignedIn()
  },
  methods: {
    signin () {
      this.$http.plain.post('/token', { email: this.email, password: this.password })
        .then(response => this.signinSuccessful(response))
        .catch(error => this.signinFailed(error))
    },
    signinSuccessful (response) {
      if (!response.data.access) {
        this.signinFailed(response)
        return
      }
      
      this.$localStorage.access = response.data.access
      this.$localStorage.email = this.email
      localStorage.email = this.email
      this.$localStorage.signedIn = true
      this.$router.replace('/dashboard')
    },
    signinFailed (error) {
      if (error.response && error.response.data) {
        this.errors = error.response.data
      }
      this.$localStorage.email = null
      this.$localStorage.access = null
      this.$localStorage.signedIn = false
    },
    checkSignedIn () {
      if (localStorage.signedIn) {
        this.$router.replace('/dashboard')
      }
    }
  }
}
</script>

<style>

</style>